export function splitMinutes(value) {
  const total = integerValue(value);
  if (!Number.isInteger(total) || total <= 0) return { hours: "", minutes: "" };

  const hours = Math.floor(total / 60);
  const minutes = total % 60;

  return {
    hours: hours > 0 ? String(hours) : "",
    minutes: minutes > 0 ? String(minutes) : "",
  };
}

export function combineHoursMinutes(hoursValue, minutesValue) {
  const hours = integerValue(hoursValue, 0);
  const minutes = integerValue(minutesValue, 0);
  if (hours < 0 || minutes < 0) return "";

  const total = (hours * 60) + minutes;
  return total > 0 ? String(total) : "";
}

export function isValidMinuteTotal(value) {
  const minutes = integerValue(value);
  return Number.isInteger(minutes) && minutes > 0 && minutes <= 1440;
}

export function formatMinutesDuration(value) {
  if (value === "" || value === null || value === undefined) return null;

  const minutes = integerValue(value);
  if (!Number.isInteger(minutes) || minutes <= 0) return null;

  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  const parts = [];

  if (hours > 0) parts.push(`${hours} hour${hours === 1 ? "" : "s"}`);
  if (remainingMinutes > 0) {
    parts.push(`${remainingMinutes} minute${remainingMinutes === 1 ? "" : "s"}`);
  }

  return parts.join(" ");
}

export function formatMinutesSummary(value) {
  const minutes = integerValue(value);
  const duration = formatMinutesDuration(value);
  if (!duration) return null;

  if (minutes < 60) return duration;

  return `${duration} (${minutes.toLocaleString()} min)`;
}

function integerValue(value, blankFallback = null) {
  if (value === "" || value === null || value === undefined) return blankFallback;
  if (!/^\d+$/.test(String(value))) return NaN;

  return Number.parseInt(value, 10);
}
